import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewEncapsulation,
	ChangeDetectorRef,
} from '@angular/core';
import { Router } from '@angular/router';
import {
	AccountCarrierMapDTO,
	CarrierDTOResponse,
	ContactsTable,
	DATE_MDY,
	IS_NOT_EMPTY,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
	ProjectCarrierMapDTO,
	ProjectDTO,
	RestService,
	TruckSearchTable,
	PROJECT_CARRIER_MAP_STATUS,
	Owner,
} from 'cargo-chief-commons';
import { CarrierToProjectsMap } from '@domain/interface/carrier-to-projects-map';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { ProjectHelperService } from '@service/projectHelper/project-helper.service';
import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { CarrierFeedbackService } from '@service/carrierFeedback/carrier-feedback.service';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';
import { ACCOUNT_TYPE, COPY_TO_CLIPBOARD_MSGS } from '@domain/constants/app-variables';
import { ProductsService } from '@service/products/products.service';
import { UserCarrierMapHelperService } from '@service/userCarrierMapHelper/user-carrier-map-helper.service';
import { SharedService } from '@service/shared/shared.service';
import { CarrierVettingService } from '@service/carrier-vetting/carrier-vetting.service';
import { SHOW_IN_NETWORK_LOGO } from '@shared/utils/in-network';
import { IntegrationService } from '@service/integration/integration.service';

@Component({
	selector: 'app-procured-carriers',
	templateUrl: './procured-carriers.component.html',
	styleUrls: ['./procured-carriers.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ProcuredCarriersComponent implements OnInit {
	@Input() projectCarrierMapList: Array<ProjectCarrierMapDTO> = [];
	@Input() selectedProjectCarrierMapIDs: Array<string> = [];
	@Input() isCarrierRatesEnabled: boolean = false;
	@Input() accountCarrierLanes: any = {};
	@Input() projectDTO: ProjectDTO = {} as ProjectDTO;
	@Input() allProjectsList: Array<ProjectDTO> = [];
	@Input() projectsNextPage: boolean = false;
	@Input() isLoadingProjectsList: boolean = false;
	@Input() totalNumberOfProjects = 0;
	@Input() isLoadingAccountCarrierLanes: boolean = false;
	@Input() searchTruckForm: any = null;
	@Input() usersList: Array<Owner> = [];
	@Input() userCarrierMapList: Array<any> = [];
	@Input() userCarrierMap: any = {};
	@Input() isCarrierVettingIntegrationEnabled!: boolean;
	@Input() CARRIER_QUALITY_ENABLED!: boolean;

	@Output() openFullProfileEvent: EventEmitter<{ projectCarrierMap: any; event: MouseEvent }> =
		new EventEmitter();
	@Output() fireSegmentEvent: EventEmitter<{
		projectId: string;
		carrierId: string;
		cIndex: number;
	}> = new EventEmitter();
	@Output() panelClicked: EventEmitter<{
		projectCarrierMap: ProjectCarrierMapDTO;
		event: MouseEvent;
	}> = new EventEmitter();

	IS_NOT_NULL_OR_UNDEFINED = IS_NOT_NULL_OR_UNDEFINED;
	IS_NULL_OR_UNDEFINED = IS_NULL_OR_UNDEFINED;
	DATE_MDY = DATE_MDY;
	IS_NOT_EMPTY = IS_NOT_EMPTY;
	COPY_TO_CLIPBOARD_MSGS = COPY_TO_CLIPBOARD_MSGS;
	SHOW_IN_NETWORK_LOGO = SHOW_IN_NETWORK_LOGO;

	step = null;
	selectedMatch: ProjectCarrierMapDTO = null;
	isContactsListInProgress: boolean = false;
	contactList: ContactsTable[] = null;
	accountId: number;
	ACCOUNT_TYPE = ACCOUNT_TYPE;
	USER_ACCOUNT_TYPE: string = null;

	constructor(
		private urlService: UrlService,
		private restService: RestService,
		public utilService: UtilService,
		public cargochief: Cargochief,
		public projectHelperService: ProjectHelperService,
		private segmentWrapper: SegmentWrapperService,
		private dialog: MatDialog,
		private carrierFeedbackService: CarrierFeedbackService,
		public accountSettings: AccountSettingsService,
		private router: Router,
		public productsService: ProductsService,
		private userCarrierMapHelperService: UserCarrierMapHelperService,
		private sharedService: SharedService,
		private cd: ChangeDetectorRef,
		public carrierVettingService: CarrierVettingService,
		public integrationService: IntegrationService
	) {
		this.USER_ACCOUNT_TYPE = this.cargochief.USER_ACCOUNT_TYPE;
		this.isCarrierVettingIntegrationEnabled =
			this.integrationService.isCarrierVettingIntegrationEnabled();
	}

	ngOnInit(): void {
		this.accountId = this.cargochief.ACCOUNT_ID;
	}

	setStep(index: number) {
		this.step = index;
		setTimeout(() => {
			this.selectedMatch = this.projectCarrierMapList[index];
			this.getContactsList();
		}, 400);
	}

	matchClosed() {
		this.selectedMatch = null;
	}

	emitPanelClickedEvent(projectCarrierMap: ProjectCarrierMapDTO, event: MouseEvent) {
		this.panelClicked.emit({ projectCarrierMap, event });
	}

	getContactsList() {
		this.isContactsListInProgress = true;
		this.contactList = null;
		const contactsUrl = this.urlService.contactsUrl(this.selectedMatch.carrier.id);
		this.restService.GET(contactsUrl).subscribe(
			(result) => {
				result['carrier'] = this.getCarrierInfo();
				this.segmentWrapper.fireSegmentEvent(SegmentEventsConstants.contact_requested, result);
				this.contactList = result['data'];
				this.isContactsListInProgress = false;
				if (!this.utilService.isNullOrUndefined(this.contactList) && this.contactList.length == 0) {
					this.segmentWrapper.fireSegmentEvent(
						SegmentEventsConstants.carrier_missing_contact_info,
						{ carrier: this.getCarrierInfo() }
					);
				}
			},
			(error) => {
				this.utilService.showSnackbar(
					'Cannot fetch contact list.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
				this.contactList = [];
				this.isContactsListInProgress = false;
			}
		);
	}

	getCarrierInfo() {
		return {
			businessName: this.selectedMatch.carrier.businessName,
			mc: this.selectedMatch.carrier.mc,
			dot: this.selectedMatch.carrier.dot,
			carrierId: this.selectedMatch.carrier.id,
		};
	}

	updateContactsList(updatedList: Array<ContactsTable>) {
		this.contactList = [...updatedList];
	}

	emitOpenFullProfileEventEvent(projectCarrierMap: ProjectCarrierMapDTO, event: MouseEvent) {
		this.router.navigate([], {
			queryParams: {
				fullProfile: 'true',
			},
			queryParamsHandling: 'merge',
		});
		this.openFullProfileEvent.emit({ projectCarrierMap, event });
	}

	async reportDataAction(dataType: string, carrier: CarrierDTOResponse) {
		const capacitySearch: Partial<TruckSearchTable> = {
			businessName: carrier.businessName,
			carrierId: carrier.id,
			firmMc: carrier.mc,
			firmDot: carrier.dot,
			carrierHQ: carrier?.city + ',' + carrier?.state,
			originCity: this.projectDTO?.originCity,
			originState: this.projectDTO?.originState,
			destCity: this.projectDTO?.destCity,
			destState: this.projectDTO?.destState,
			lanePath: this.projectHelperService.getLanePath(this.projectDTO),
			phone: carrier.phone,
			drivers: carrier.drivers,
			trailerTypes: this.projectDTO?.equipmentType,
		};
		await this.carrierFeedbackService.reportDataAction(
			dataType,
			this.searchTruckForm,
			capacitySearch
		);
	}

	getUserIdAssigned(carrierId: string): number {
		return this.userCarrierMapList.filter((cMap: any) => cMap.carrierId == carrierId)[0].assigneeId;
	}

	setAssignee(user: Owner, carrierId: string) {
		if (!this.utilService.isNullOrUndefined(user)) {
			const cMap: any = this.userCarrierMapList.filter(
				(cMap: any) => cMap.carrierId == carrierId
			)[0];
			if (
				this.utilService.isNullOrUndefined(cMap) ||
				(!this.utilService.isNullOrUndefined(cMap) && cMap.assigneeId != user.userId)
			) {
				this.addUserCarrierMap(user, carrierId);
			}
		} else if (
			this.utilService.isNullOrUndefined(user) &&
			!this.utilService.isNullOrUndefined(this.userCarrierMap)
		) {
			const userCarrierMapId: string = this.userCarrierMapList.filter(
				(cMap: any) => cMap.carrierId == carrierId
			)[0].id;
			if (!this.utilService.isNullOrUndefined(userCarrierMapId)) {
				this.deleteUserCarrierMap(carrierId, userCarrierMapId);
			}
		}
	}

	addUserCarrierMap(user: Owner, carrierId: string) {
		const payload = this.userCarrierMapHelperService.createPayload(user.userId, carrierId, false);
		const url = this.urlService.userCarrierMap();
		this.restService.POST(url, payload).subscribe(
			(result) => {
				this.userCarrierMap[carrierId] = user.name;
				this.utilService.showSnackbar('User Assigned.', SNACKBAR.SUCCESS, SNACKBAR.ACTION);
				this.sharedService.sendCarrierAssignedEvent({
					deleted: false,
					carrierId: carrierId,
					assigneeName: user.name,
					userCarrierMap: result.data,
				});
				this.userCarrierMapList = this.userCarrierMapList.filter(
					(cMap: any) => cMap.carrierId != carrierId
				);
				this.userCarrierMapList.push(result.data);
			},
			(error) => {
				this.utilService.showSnackbar(
					'Unable to set Assignee. Please try again.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
			}
		);
	}

	deleteUserCarrierMap(carrierId: string, userCarrierMapId: string) {
		const payload = {
			userCarrierMapIDs: [userCarrierMapId],
		};
		const url = this.urlService.userCarrierMap();
		this.restService.DELETE(url, payload).subscribe(
			(result) => {
				delete this.userCarrierMap[carrierId];
				this.utilService.showSnackbar('Assignee removed.', SNACKBAR.SUCCESS, SNACKBAR.ACTION);
				this.sharedService.sendCarrierAssignedEvent({
					deleted: true,
					carrierId: carrierId,
				});
				this.userCarrierMapList = this.userCarrierMapList.filter(
					(cMap: any) => cMap.carrierId != carrierId
				);
			},
			(error) => {
				this.utilService.showSnackbar(
					'Unable to delete Assignee. Please try again.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
			}
		);
	}

	drag(event: any, projectCarrierMap: ProjectCarrierMapDTO) {
		this.cd.detach();
		let projectCarrierMapIds: string;
		if (this.selectedProjectCarrierMapIDs.length === 0) {
			projectCarrierMapIds = projectCarrierMap.id;
		} else {
			projectCarrierMapIds = this.selectedProjectCarrierMapIDs.join();
		}
		event.dataTransfer.setData('carrierId', projectCarrierMapIds);
	}

	dragend() {
		this.cd.reattach();
		this.selectedProjectCarrierMapIDs = [];
	}

	isFrequencyValidNumber(frequency): boolean {
		return !/\D/.test(frequency);
	}

	getCcScoreDisplay(accountCarrierMaps: AccountCarrierMapDTO[]) {
		if (!accountCarrierMaps || accountCarrierMaps.length === 0) {
			return null;
		}

		var accountCarrierMap = accountCarrierMaps.find((acm) => acm.accountId === this.accountId);

		return this.sharedService.getCarrierScoreToDisplay(accountCarrierMap?.ccScore);
	}

	getVettingSourceId(accountCarrierMaps: AccountCarrierMapDTO[]): any {
		return accountCarrierMaps?.find((acm) => acm.accountId === this.accountId)?.vettingSourceId;
	}

	getVettingSource(accountCarrierMaps: AccountCarrierMapDTO[]): any {
		return accountCarrierMaps?.find((acm) => acm.accountId === this.accountId)?.vettingSource;
	}
}
